import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {PopinOneComponent} from './popin-one/popin-one.component';
import {PopinTwoComponent} from './popin-two/popin-two.component';
import {TestComponent} from './test/test.component';
import {PopinVisitorComponent} from './popin-visitor/popin-visitor.component';
import {PopinThreeComponent} from './popin-three/popin-three.component';
import {PopinFourComponent} from './popin-four/popin-four.component';
import {VisitorRedirectComponent} from './visitor-redirect/visitor-redirect.component';
import {FourOhFourComponent} from './four-oh-four/four-oh-four.component';
import {PopinExitComponent} from './popin-exit/popin-exit.component';


const routes: Routes = [
  {path: ':visitRandomId/:url', component: PopinOneComponent},
  {path: ':visitRandomId/:url/edit', component: PopinOneComponent},
  {path: 'customer', component: PopinThreeComponent},
  {path: 'customer/:helpType', component: PopinTwoComponent},
  {path: 'customer/:helpType/:product', component: PopinFourComponent},
  {path: 'visitor', component: PopinVisitorComponent},
  {path: 'visitor/redirect/:id/:url', component: VisitorRedirectComponent},
  {path: 'exit-popin', component: PopinExitComponent},
  {path: 'test', component: TestComponent},
  {path: 'not-found', component: FourOhFourComponent},
  {path: '**', redirectTo: '/not-found'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
